import React, { useContext, useEffect, useState } from 'react';
import { Icon, FileUploader, message } from '@tencent/spaui';
import { RegistContext } from '../context';

// eslint-disable-next-line
export default (props: {
  max?: number;
  onChange: (list: any) => void;
  data?: [{ file_name: string; file_url: string }];
  maxSize?: number;
}) => {
  const { max = 10, onChange } = props;
  const [list, setList] = useState([{}]);
  const { userIdentity } = useContext(RegistContext);

  // eslint-disable-next-line
  const handleListChange = (list: any) => {
    setList(list);
    onChange(list);
  };

  const fileFilter = (fileInfo: File) => {
    const max = props.maxSize || 10;
    const { size } = fileInfo;

    if (size > max * 1024 * 1024) {
      message.error(`文件大小超过${max}M限制`);
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (!props.data || !props.data.length) {
      return;
    }
    const dataList = props.data.map((item) => {
      const { file_name, file_url } = item;
      return {
        file_name,
        file_url,
        url: file_url,
        name: file_name,
        status: 'success',
      };
    });
    handleListChange(dataList);
    // eslint-disable-next-line
  }, []);

  return (
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 1, paddingRight: '20px' }}>
        {list?.map((item: { status?: string }, index) => (
          <div key={index} style={{ marginBottom: '8px', display: 'flex', justifyContent: 'space-between' }}>
            <FileUploader
              name="file"
              url="/isv_service/v1/agency/update_file"
              data={{ flow_key: userIdentity }}
              value={item}
              filter={fileFilter}
              onDelete={() => {
                list.splice(index, 1);
                handleListChange([...list]);
              }}
              onComplete={(response: any = {}, fileTarget: any) => {
                const { file_url, file_id } = response.data?.[0] || {};
                if (response.code === 0 && !!file_url.trim?.()) {
                  list[index] = {
                    url: file_url,
                    name: fileTarget.name,
                    status: 'success',
                    file_name: fileTarget.name,
                    file_url,
                    file_id,
                    fileId: file_id,
                  };
                } else {
                  list[index] = {
                    name: fileTarget.name,
                    status: 'fail',
                  };
                  message.error(response.msg);
                }
                handleListChange([...list]);
              }}
            />
            {list.length > 1 && !item.status && (
              <span
                style={{ marginTop: '10px', cursor: 'pointer' }}
                className="spaui-upfile-icon-del"
                onClick={() => {
                  list.splice(index, 1);
                  handleListChange([...list]);
                }}
              />
            )}
          </div>
        ))}
      </div>
      {list.length < max && (
        <Icon
          style={{ marginTop: '10px', cursor: 'pointer' }}
          name="plus-bold-outlined"
          onClick={() => {
            list.push({});
            setList([...list]);
          }}
        />
      )}
    </div>
  );
};
